export function isDuplicateMark(node, type) {
  if (node.marks && node.marks.some(function (mark) {
    return mark.type === type;
  })) {
    return true;
  }
  return false;
}
export function duplicateMarkError(node, type) {
  return "Mark with the same name '".concat(type, "' already exists on a node: ").concat(JSON.stringify(node));
}